import { PropsWithChildren } from 'react';
import { sendButtonClickEvent } from '../services/trackerManager';
import {
  IconButton,
  IconButtonProps,
  ButtonProps as MuiButtonProps,
  Button as MuiButton,
} from '@mui/material';
import { Button } from '@chargeafter/ui';
import { ButtonProps } from '@chargeafter/ui/src/lib/components/Button/Button';
import { Loader } from './Loader';

interface TrackerButtonProps {
  buttonName: string;
  loading?: boolean;
  loaderColor?: string;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

interface TrackerCaButtonProps
  extends Omit<ButtonProps, 'onClick'>,
    TrackerButtonProps {}

interface MuiTrackerButtonProps
  extends Omit<MuiButtonProps, 'onClick'>,
    TrackerButtonProps {}

interface TrackerIconButtonProps
  extends Omit<IconButtonProps, 'onClick'>,
    TrackerButtonProps {}

export const TrackerButton = ({
  buttonName,
  onClick,
  children,
  loading,
  loaderColor,
  ...rest
}: TrackerCaButtonProps & PropsWithChildren) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    sendButtonClickEvent({ buttonName });

    onClick?.(e);
  };
  return (
    <Button onClick={handleClick} {...rest}>
      {!loading ? <>{children}</> : <Loader color={loaderColor} />}
    </Button>
  );
};

export const MuiTrackerButton = ({
  buttonName,
  onClick,
  loading,
  children,
  loaderColor,
  ...rest
}: MuiTrackerButtonProps & PropsWithChildren) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    sendButtonClickEvent({ buttonName });

    onClick?.(e);
  };
  return (
    <MuiButton onClick={handleClick} {...rest}>
      {!loading ? <>{children}</> : <Loader color={loaderColor} />}
    </MuiButton>
  );
};

export const TrackerIconButton = ({
  buttonName,
  onClick,
  ...rest
}: TrackerIconButtonProps & PropsWithChildren) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    sendButtonClickEvent({ buttonName });
    onClick?.(e);
  };
  return <IconButton onClick={handleClick} {...rest} />;
};
